export const InvalidDateEnum = {
    INVALID_DATE: 'Invalid date',
}
